import { defineComponent } from 'vue';

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlWhatsnew',
    props: {
        title: {
            type: String,
            default: "",
            required: true
        },
        message: {
            type: String,
            default: "",
            required: true
        }
    },
    setup(props) {

        return {};
    }
});
